import React, {
  Dispatch,
  SetStateAction,
  useEffect,
  useRef,
  useState,
} from 'react'
import styled from 'styled-components'
import { RootState, useAppDispatch, useAppSelector } from '../../store'
import LeftSide from '../Mentor/Mentee/LeftSide'
import {
  asyncGetFriends,
  asyncGetMentees,
  updateMenteeInfo,
} from '../../store/mainSlice'
import { Job as JobData } from '../../models/Job'
import Job from '../Common/Job'
import { JobRecommend } from '../../models/JobRecommend'
import axios from 'axios'
import { UserGroupDto } from '../../models/Dto/UserGroupDto'
import TextAreaBox from '../Common/TextAreaBox'
import { axiosPost } from '../Common/Axios'
import { FriendToUser } from '../../models/FriendToUser'
import { TomatoButton } from '../Layout/CommonStyle'
import toast from 'react-hot-toast'

interface OtherProps {
  setOpen: Dispatch<SetStateAction<boolean>>
  job: JobData
}

const RecommandFriendForm = (props: OtherProps) => {
  const [friend, setFriend] = useState<FriendToUser | undefined>(undefined)
  const [recommendContent, setRecommendContent] = useState<string>('')
  const [updateJobRecomend, setUpdateJobRecomend] = useState<boolean>(false)
  const recommendTextareaRef = useRef<HTMLTextAreaElement>(null)
  const dispatch = useAppDispatch()

  const me = useAppSelector((state: RootState) => state.user.me)
  const friends = useAppSelector((state: RootState) => state.main.friends)

  useEffect(() => {
    const loadFriends = async () => {
      await dispatch(asyncGetFriends(me.id))
    }

    loadFriends()
    // if (!friends || friends.length == 0) {
    //   loadFriends()
    // }
  }, [])

  useEffect(() => {
    if (friends.length > 0) {
      setFriend(friends[0])
    }
  }, [friends])

  const onChangeFriend = async (e: React.ChangeEvent<HTMLSelectElement>) => {
    const id = e.target.value
    setFriend(friends.find((f) => f.friend.id === parseInt(id)))
  }

  // 추천이유 적용 클릭시
  const updateRecommendContent = (value: string) => {
    setRecommendContent(value)
  }
  const insertRecommend = async () => {
    if (friend === undefined) {
      return
    }

    const payload: JobRecommend = {
      id: 0,
      jobId: props.job.id,
      isFromMentor: false,
      sendUserId: me.id,
      recvUserId: friend.friend.id,
      recommendContent: recommendContent,
    }

    const data = await axiosPost('/api/mentee/insert_recommend', payload)
    if (data === 'exist') {
      toast.error('이미 추천한 직업입니다.')
      return
    }

    toast.success('추천했습니다.')
    props.setOpen(false)
  }

  return (
    <Container>
      <Title>직업 추천</Title>
      <Content>
        <Main>
          <Job
            id={props.job.id}
            name={props.job.name}
            image={props.job.photo}
            description={props.job.overview}
          />

          <div>
            <select onChange={onChangeFriend}>
              {friends &&
                friends.map((friend) => (
                  <option key={friend.friend.id} value={friend.friend.id}>
                    {friend.friend.username}
                  </option>
                ))}
            </select>{' '}
            님에게 추천
          </div>
          <div>추천이유</div>
          <TextAreaBox
            updateId={friend?.id ?? 0}
            value=""
            placeholder="추천하는 이유를 알려주세요."
            updateValue={updateRecommendContent}
            isShowButtons={false}
            height="80px"
          />
          <TomatoButton onClick={() => insertRecommend()}>추천</TomatoButton>
        </Main>
      </Content>
    </Container>
  )
}

const Container = styled.div`
  min-width: 80%;

  @media (max-width: 768px) {
    width: calc(80vw);
  }
  Button {
    width: 100%;
  }
`

const Content = styled.div`
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    padding: 0;
    margin: 0 0 10px 0;
    width: 100%;
  }
`
const Title = styled.div`
  margin-bottom: 20px;
  font-size: 1.5rem;
  text-align: center;
  color: #666;
`

const Main = styled.div`
  padding: 5px 20px;

  div:nth-child(2) {
    select {
      padding: 5px 10px;
      margin-top: 5px;
    }
    padding-bottom: 10px;
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 0;
  }
`

export default RecommandFriendForm
